export const handleClick = (onClick: any) => onClick && onClick();

export const handleTouchStart = (onTouchStart: any, e?: any) => onTouchStart && onTouchStart(e);

export const handleTouchEnd = (onTouchEnd: any) => onTouchEnd && onTouchEnd();

export const handleMouseDown = (onMouseDown: any, e?: any) => onMouseDown && onMouseDown(e);

export const handleMouseUp = (onMouseUp: any) => onMouseUp && onMouseUp();

export const handleMouseLeave = (onMouseLeave: any) => onMouseLeave && onMouseLeave();
